var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseNavItem',{attrs:{"title":_vm.$t('labels.clients'),"icon":_vm.$vuetify.icons.values.clients,"route":_vm.targetRoute,"visible":_vm.visible}})
}
var staticRenderFns = []

export { render, staticRenderFns }